export * from './deals-actions'



/** WEBPACK FOOTER **
 ** ./src/actions/entities/deals/index.js
 **/